<template>
    <v-container
        :id="section._id"
        :class="{
            'anchortabs text-center pt-0 pb-0 bg--dkblue': true,
            'anchortabs--md-and-down': $vuetify.breakpoint.mdAndDown,
            'anchortabs--lg-and-up': $vuetify.breakpoint.lgAndUp
        }"
        fluid
    >
        <v-row column justify-center align-center>
            <v-col cols="12" class="pt-0 pb-0">
                <CtaLinks :links="section.ctaLinks.links" layout="AnchorTabs" />
                <!-- <pre style="text-align:left">{{ section }}</pre> -->
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import CtaLinks from '~/components/CtaLinks'
import serializers from '~/util/sanity/serializers'
export default {
    name: 'CtaAnchorTabs',
    components: {
        CtaLinks
    },
    props: {
        section: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            serializers
        }
    }
}
</script>
